import { Injectable } from '@angular/core';
import { MessageService } from 'brainloper-ui';
import { environment } from 'environments/environment';
import { getMessaging, getToken } from 'firebase/messaging';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationsService {

  private messaging = getMessaging();

  constructor(
    private message: MessageService
    ) { 
     } 
     
     async getNotificationPermission(): Promise<NotificationPermission> {
      try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
          return permission;
        } else {
          this.message.Error('Error', 'Debe permitir envio de notificaciones');
          throw new Error('Notification permission denied');
        }
      } catch (err) {
        throw err;
      }
    }
    
  

  // obtener el token
  async getNotificationToken(callback: (token: string) => void): Promise<void> {
    this.message.openLoading('Cargando', 'Obteniendo permisos');
    try {
     const permission = await this.getNotificationPermission();
      const token = await this.retrieveToken();
      callback(token);
    } catch (err) {
      console.error('Error getting notification token or permission denied:', err);
    }
     this.message.closeLoading();    
  }

  // Función para obtener el token de notificación
  private async retrieveToken(): Promise<string> {
    try {
        // Verificar si el Service Worker está registrado y listo
        const registration = await navigator.serviceWorker.ready;
        if (!registration) {
            throw new Error('No active Service Worker');
        }

        // Intentar recuperar el token de notificación
        const token = await getToken(this.messaging, { vapidKey: environment.publicKeyToken });
        if (token) {
            return token;
        } else {
            this.message.Error('Error', 'No se pudo obtener el token de notificaciones');
            throw new Error('No registration token available');
        }
    } catch (err) {
        this.message.Error('Error', 'Error obteniendo el token de notificaciones');
        throw err;
    }
}
}
